<template>
    <div 
        class="o-units-line" 
        :style="lineStyles"
    >
        <div
            :class="`o-units-line__dashed ${animation ? 'animation' : ''}`"
        />
    </div>
</template>

<script>
import {POSTER_FLOOR_ACTIVE_LABEL_ID} from '../../../utils/constants/other'

export default {
    name: "OUnitsLine",
    inject: ['mapViewer'],
    props: {
        startUnit: {
            type: [String, Number],
            require: true
        },
        finishUnit: {
            type: [String, Number],
            require: true
        },
        startPositionX: {
            type: Boolean,
            default: false
        },
        widthCut: {
            type: Number,
            default: 0
        },
        animation: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            lineStyles: null
        }
    },
    methods: {
        lineDistance(x, y, x0, y0){
            return Math.sqrt((x -= x0) * x + (y -= y0) * y);
        },
        getAngle(y0, y, x0, x) {
            return Math.atan2(y0 - y, x0 - x) * 180 / Math.PI;
        },
        handleCameraUpdate() {
            
            const startUnitPos = this.mapViewer.viewApi[`get_unit_screen_pos`](this.startUnit);
            const finishUnitPos = this.mapViewer.viewApi[`get_unit_screen_pos`](this.finishUnit);

            if (startUnitPos && finishUnitPos) {

                const startPosx = !!this.startPositionX && this.getXPositionFromElement()? this.getXPositionFromElement() : startUnitPos.x
                
                const lineWidth = this.lineDistance(startPosx, startUnitPos.y, finishUnitPos.x, finishUnitPos.y);
                const lineAngle = this.getAngle(finishUnitPos.y, startUnitPos.y, finishUnitPos.x, startPosx)

                this.lineStyles = {
                    width: `calc(${lineWidth}px - ${this.widthCut}vw)`,
                    transform: `rotate(${lineAngle}deg)`,
                }
            } else {
                this.lineStyles = {
                    display: 'none'
                }
                console.error(`OUnitsLine: can't get position for unit`)
            }
        },
        getXPositionFromElement() {
            const hereIcon = document.getElementById(POSTER_FLOOR_ACTIVE_LABEL_ID);
            return hereIcon?.getBoundingClientRect().width - 2
        }
    },
    mounted(){
        this.mapViewer.viewApi.register_event('on_camera_update', this.handleCameraUpdate);

        this.handleCameraUpdate();
    },
    beforeDestroy(){
        this.mapViewer.viewApi.deregister_event('on_camera_update', this.handleCameraUpdate);
    }
}
</script>

<style lang="scss">
@import "o-units-line";
</style>
